var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.107 16.102c.31.309.81.309 1.12 0l2.374-2.375c.31-.31.31-.81 0-1.12l-2.375-2.375a.792.792 0 0 0-1.12 1.12l1.024 1.023H7.125A2.375 2.375 0 0 1 4.75 10V4.458a.792.792 0 1 0-1.583 0V10a3.958 3.958 0 0 0 3.958 3.959h6.005l-1.023 1.023c-.31.31-.31.81 0 1.12z",
    fill: "#959396"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.79c1e3a1bf43097060c4abe01f564393.svg";
export { ForwardRef as ReactComponent };